import { useAppointmentProposalSurveyOptions } from '@airship-platform/airship-patterns';
import {
  EmptyState,
  Loader,
  LoadingButton,
} from '@airship-platform/jam-web/components';
import { Link, useNavigate } from 'react-router';
import { useAppointmentProposalFiles } from '../../../data-access/appointmentProposalFiles';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import { SectionWrapper } from '../../../patterns';
import MediaSection, { MediaSectionInputs } from './sections/MediaSection';

const FORM_ID = 'proposalCaptureMediaForm';

const CaptureMediaPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentProposal, isLoading, updateAppointmentProposal } =
    useAppointmentProposals();
  const { mediaChecklistOptions } = useAppointmentProposalSurveyOptions();

  const { isLoading: isLoadingFiles, isLoaded: isLoadedFiles } =
    useAppointmentProposalFiles();

  if (isLoadingFiles && !isLoadedFiles) {
    return <Loader isLoading={isLoadingFiles} message="Loading Assets" />;
  }

  if (!currentProposal) {
    return (
      <EmptyState
        title="Appointment not found"
        subtitle="Oops! The requested appointment was not found."
      />
    );
  }

  const onSubmit = (mediaChecklist: MediaSectionInputs) =>
    updateAppointmentProposal(
      currentProposal.appointmentId,
      currentProposal.appointmentProposalId,
      { mediaChecklist }
    ).then(() => navigate('../service-menu'));

  return (
    <SectionWrapper
      maxWidth={'sm'}
      width={'100%'}
      header="Add media of the existing system to display in the proposal."
      actionsButtons={{
        left: {
          color: 'softGold',
          component: Link,
          to: '../service-menu',
          label: 'Cancel',
        },
        right: {
          type: 'submit',
          component: LoadingButton,
          form: FORM_ID,
          label: 'Save',
          loading: isLoading,
          disabled: isLoading,
        },
      }}
    >
      <MediaSection
        formId={FORM_ID}
        checklistOptions={mediaChecklistOptions}
        defaultValues={currentProposal.mediaChecklist}
        onSubmit={onSubmit}
      />
    </SectionWrapper>
  );
};

export default CaptureMediaPage;
